/**
 * Canonical list of client testimonials. Used by:
 * - The Home page "Testimonials" preview carousel
 * - The full Testimonials page (grid + average rating summary)
 */
const testimonials = [
  {
    id: "abebe-kebede",
    name: "Abebe Kebede",
    role: "Homeowner, Riverside Family Home",
    avatar:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=200&q=80",
    rating: 5,
    quote:
      "NAF Construction turned our vision into reality with precision and care. Every deadline was met, and the craftsmanship exceeded what we imagined possible for our budget.",
  },
  {
    id: "sara-tesfaye",
    name: "Sara Tesfaye",
    role: "CEO, Meskel Business Group",
    avatar:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=200&q=80",
    rating: 5,
    quote:
      "From the first consultation to the final walkthrough, the team communicated clearly and managed our commercial tower project with genuine professionalism throughout.",
  },
  {
    id: "daniel-molla",
    name: "Daniel Molla",
    role: "Property Owner, Heritage Villa",
    avatar:
      "https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?auto=format&fit=crop&w=200&q=80",
    rating: 4,
    quote:
      "Renovating a heritage property required real sensitivity to the original design. NAF Construction respected that history while modernizing everything we needed.",
  },
  {
    id: "hiwot-desta",
    name: "Hiwot Desta",
    role: "Owner, Sunrise Apartments",
    avatar:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=200&q=80",
    rating: 5,
    quote:
      "Managing a 40-unit complex across phases is no small task, but the project management team kept everything transparent and on schedule from start to finish.",
  },
  {
    id: "samuel-fikru",
    name: "Samuel Fikru",
    role: "Retail Developer, Lakeview Plaza",
    avatar:
      "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=200&q=80",
    rating: 4,
    quote:
      "Solid communication and dependable quality. There were minor hiccups early on, but the team addressed every concern quickly and professionally.",
  },
  {
    id: "tigist-ashenafi",
    name: "Tigist Ashenafi",
    role: "Homeowner, Modern Loft Remodel",
    avatar:
      "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=200&q=80",
    rating: 5,
    quote:
      "I couldn't be happier with how my loft turned out. The interior design team really listened to what I wanted and delivered beyond expectations.",
  },
];

export default testimonials;